const actionTypes = require('../../actionTypes.js');
const stateBuilder = require("../../stateBuilder.js")

module.exports.createAction = function (basketVersion)
{
    return (
        {
            type: actionTypes.basketVersion,
            payload: basketVersion
        }
    );
}

module.exports.changeState = function (previousState, payload)
{
    if (payload == null)
        return stateBuilder.createState();
    else
        return Object.assign({}, previousState, { basketVersion: payload });
}